import { jsx as l, jsxs as P } from "react/jsx-runtime";
import { c as ce } from "react/compiler-runtime";
import { TextField as he, Box as B, InputAdornment as de, Typography as pe, MenuItem as ne, FormControl as xe, Select as ve, Popover as Se, Checkbox as be, Tooltip as _e } from "@mui/material";
import { u as ae, F as re, a as U } from "../../../chunks/TableContext.js";
import { useState as se } from "react";
import ge from "@mui/icons-material/Search";
import { FixedSizeList as Fe } from "react-window";
import { styles as D } from "./styles.js";
import Te from "./TimeRangeFilter.js";
const Ie = (f) => {
  const e = ce(37), {
    columnId: t,
    anchorEl: i,
    onClose: r
  } = f, {
    setColumnFilter: x,
    columnFilters: h,
    setColumnFilters: a
  } = ae();
  let v;
  e[0] !== h || e[1] !== t ? (v = h.find((s) => s.id === t)?.value, e[0] = h, e[1] = t, e[2] = v) : v = e[2];
  const S = v, [n, y] = se(S?.operator || U.IN);
  let $;
  e[3] !== t || e[4] !== n || e[5] !== x ? ($ = (s) => {
    s.trim() ? x(t, {
      value: s,
      operator: n
    }) : x(t, "");
  }, e[3] = t, e[4] = n, e[5] = x, e[6] = $) : $ = e[6];
  const N = $;
  let u;
  e[7] !== h || e[8] !== t || e[9] !== a ? (u = (s) => {
    if (y(s), h.filter((W) => W.id === t).length > 0) {
      const W = h.map((p) => p.id === t ? p.value && typeof p.value == "object" && "value" in p.value ? {
        ...p,
        value: {
          ...p.value,
          operator: s
        }
      } : {
        ...p,
        value: {
          value: p.value,
          operator: s
        }
      } : p);
      a(W);
    }
  }, e[7] = h, e[8] = t, e[9] = a, e[10] = u) : u = e[10];
  const R = u, L = !!i;
  let d, F;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = {
    vertical: "bottom",
    horizontal: "right"
  }, F = {
    vertical: "top",
    horizontal: "right"
  }, e[11] = d, e[12] = F) : (d = e[11], F = e[12]);
  let G;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, e[13] = G) : G = e[13];
  let g;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = {
    minWidth: 120
  }, e[14] = g) : g = e[14];
  let M;
  e[15] !== R ? (M = (s) => R(s.target.value), e[15] = R, e[16] = M) : M = e[16];
  let T;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = {
    fontSize: "12px",
    "& .MuiSelect-select.MuiSelect-outlined": {
      padding: "6px 12px"
    }
  }, e[17] = T) : T = e[17];
  let j;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (j = /* @__PURE__ */ l(ne, { sx: {
    fontSize: "12px"
  }, value: U.IN, children: "Includes" }), e[18] = j) : j = e[18];
  let I;
  e[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (I = /* @__PURE__ */ l(ne, { sx: {
    fontSize: "12px"
  }, value: U.NOT_IN, children: "Does not include" }), e[19] = I) : I = e[19];
  let b;
  e[20] !== n || e[21] !== M ? (b = /* @__PURE__ */ l(xe, { size: "small", sx: g, children: /* @__PURE__ */ P(ve, { value: n, onChange: M, sx: T, children: [
    j,
    I
  ] }) }), e[20] = n, e[21] = M, e[22] = b) : b = e[22];
  const w = S?.value || "";
  let _;
  e[23] !== N ? (_ = (s) => N(s.target.value), e[23] = N, e[24] = _) : _ = e[24];
  let O;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (O = {
    startAdornment: /* @__PURE__ */ l(de, { position: "start", children: /* @__PURE__ */ l(ge, { sx: {
      fontSize: "16px"
    } }) })
  }, e[25] = O) : O = e[25];
  let m;
  e[26] !== w || e[27] !== _ ? (m = /* @__PURE__ */ l(he, { placeholder: "Search", variant: "outlined", size: "small", fullWidth: !0, value: w, onChange: _, sx: D.searchTextField, InputProps: O }), e[26] = w, e[27] = _, e[28] = m) : m = e[28];
  let C;
  e[29] !== b || e[30] !== m ? (C = /* @__PURE__ */ l(B, { sx: D.columnFilterContainer, children: /* @__PURE__ */ P(B, { sx: G, children: [
    b,
    m
  ] }) }), e[29] = b, e[30] = m, e[31] = C) : C = e[31];
  let E;
  return e[32] !== i || e[33] !== r || e[34] !== C || e[35] !== L ? (E = /* @__PURE__ */ l(Se, { open: L, anchorEl: i, onClose: r, anchorOrigin: d, transformOrigin: F, children: C }), e[32] = i, e[33] = r, e[34] = C, e[35] = L, e[36] = E) : E = e[36], E;
}, Oe = (f) => {
  const e = ce(64), {
    columnId: t,
    anchorEl: i,
    onClose: r,
    options: x
  } = f, {
    setColumnFilter: h,
    columnFilters: a,
    getColumnById: v,
    setColumnFilters: S,
    data: n
  } = ae(), [y, $] = se("");
  let N;
  e[0] !== t || e[1] !== v ? (N = v(t), e[0] = t, e[1] = v, e[2] = N) : N = e[2];
  const u = N, R = !!u?.filterDisableSearch;
  let L;
  e[3] !== u?.filterOptions ? (L = u?.filterOptions?.reduce(ze, {}) || {}, e[3] = u?.filterOptions, e[4] = L) : L = e[4];
  const d = L;
  let F;
  e[5] !== a || e[6] !== t ? (F = a.find((o) => o.id === t)?.value, e[5] = a, e[6] = t, e[7] = F) : F = e[7];
  const G = F, [g, M] = se(G?.operator || U.IN);
  let T;
  if (e[8] !== a || e[9] !== t) {
    let o;
    e[11] !== t ? (o = (k) => k.id === t, e[11] = t, e[12] = o) : o = e[12], T = a.filter(o).map(Ne), e[8] = a, e[9] = t, e[10] = T;
  } else
    T = e[10];
  const j = T;
  let I;
  e[13] !== t || e[14] !== g || e[15] !== h ? (I = (o) => {
    h(t, {
      value: o,
      operator: g
    });
  }, e[13] = t, e[14] = g, e[15] = h, e[16] = I) : I = e[16];
  const b = I;
  let w;
  e[17] !== a || e[18] !== t || e[19] !== S ? (w = (o) => {
    if (M(o), a.filter((z) => z.id === t).length > 0) {
      const z = a.map((c) => c.id === t ? c.value && typeof c.value == "object" && "value" in c.value ? {
        ...c,
        value: {
          ...c.value,
          operator: o
        }
      } : {
        ...c,
        value: {
          value: c.value,
          operator: o
        }
      } : c);
      S(z);
    }
  }, e[17] = a, e[18] = t, e[19] = S, e[20] = w) : w = e[20];
  const _ = w;
  let O;
  if (e[21] !== d || e[22] !== x || e[23] !== y) {
    let o;
    e[25] !== d || e[26] !== y ? (o = (k) => {
      const z = k?.toString();
      return (z ? d[z] || z : "").toLowerCase().includes(y.toLowerCase());
    }, e[25] = d, e[26] = y, e[27] = o) : o = e[27], O = x.filter(o), e[21] = d, e[22] = x, e[23] = y, e[24] = O;
  } else
    O = e[24];
  const m = O;
  let C;
  e[28] !== u || e[29] !== n || e[30] !== d || e[31] !== m || e[32] !== b || e[33] !== j ? (C = (o) => {
    const {
      index: k,
      style: z
    } = o, c = m[k], ie = c?.toString(), ue = u?.filterCustomOptionText ? u.filterCustomOptionText(n[k]) : null, Z = ue || (ie ? d[ie] || ie : ""), me = Z.length > 30, Ce = j.some((A) => A === c ? !0 : A && typeof A == "object" && "value" in A ? ("operator" in A, A.value === c) : !1), fe = u?.filterOptionIcon ? u.filterOptionIcon(n[k]) : null, ye = me && Z.length > 30 ? `${Z.slice(0, 30)}...` : Z;
    return /* @__PURE__ */ P(B, { style: z, sx: D.filterOptionRow, onClick: () => b(c), children: [
      /* @__PURE__ */ l(be, { checked: Ce, size: "small", sx: D.filterCheckbox }),
      /* @__PURE__ */ P(B, { sx: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        flex: 1,
        minWidth: 0,
        marginLeft: "8px"
      }, children: [
        fe && /* @__PURE__ */ l(B, { sx: {
          display: "flex",
          alignItems: "center"
        }, children: fe }),
        /* @__PURE__ */ l(_e, { title: me ? Z : "", arrow: !0, placement: "top", children: /* @__PURE__ */ l(pe, { variant: "body2", sx: {
          ...D.filterOptionText,
          maxWidth: "200px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }, children: ye }) })
      ] })
    ] });
  }, e[28] = u, e[29] = n, e[30] = d, e[31] = m, e[32] = b, e[33] = j, e[34] = C) : C = e[34];
  const E = C, s = !!i;
  let Y, W;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = {
    vertical: "bottom",
    horizontal: "right"
  }, W = {
    vertical: "top",
    horizontal: "right"
  }, e[35] = Y, e[36] = W) : (Y = e[35], W = e[36]);
  let p;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, e[37] = p) : p = e[37];
  let V;
  e[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = {
    minWidth: 120
  }, e[38] = V) : V = e[38];
  let X;
  e[39] !== _ ? (X = (o) => _(o.target.value), e[39] = _, e[40] = X) : X = e[40];
  let ee;
  e[41] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ee = {
    fontSize: "12px",
    "& .MuiSelect-select.MuiSelect-outlined": {
      padding: "6px 12px"
    }
  }, e[41] = ee) : ee = e[41];
  let te;
  e[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (te = /* @__PURE__ */ l(ne, { sx: {
    fontSize: "12px"
  }, value: U.IN, children: "Includes" }), e[42] = te) : te = e[42];
  let le;
  e[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (le = /* @__PURE__ */ l(ne, { sx: {
    fontSize: "12px"
  }, value: U.NOT_IN, children: "Does not include" }), e[43] = le) : le = e[43];
  let q;
  e[44] !== g || e[45] !== X ? (q = /* @__PURE__ */ l(xe, { size: "small", sx: V, children: /* @__PURE__ */ P(ve, { value: g, onChange: X, sx: ee, children: [
    te,
    le
  ] }) }), e[44] = g, e[45] = X, e[46] = q) : q = e[46];
  let H;
  e[47] !== R || e[48] !== y ? (H = !R && /* @__PURE__ */ l(he, { placeholder: "Search", variant: "outlined", size: "small", fullWidth: !0, value: y, onChange: (o) => $(o.target.value), sx: D.searchTextField, InputProps: {
    startAdornment: /* @__PURE__ */ l(de, { position: "start", children: /* @__PURE__ */ l(ge, { sx: {
      fontSize: "16px"
    } }) })
  } }), e[47] = R, e[48] = y, e[49] = H) : H = e[49];
  let J;
  e[50] !== q || e[51] !== H ? (J = /* @__PURE__ */ P(B, { sx: p, children: [
    q,
    H
  ] }), e[50] = q, e[51] = H, e[52] = J) : J = e[52];
  let K;
  e[53] !== E || e[54] !== m.length ? (K = m.length > 0 ? /* @__PURE__ */ l(Fe, { height: Math.min(250, m.length * 30), width: "100%", itemCount: m.length, itemSize: 30, overscanCount: 5, children: E }) : /* @__PURE__ */ l(B, { sx: D.noResultsText, children: /* @__PURE__ */ l(pe, { variant: "body2", color: "text.secondary", children: "No results found" }) }), e[53] = E, e[54] = m.length, e[55] = K) : K = e[55];
  let Q;
  e[56] !== J || e[57] !== K ? (Q = /* @__PURE__ */ P(B, { sx: D.columnFilterContainer, children: [
    J,
    K
  ] }), e[56] = J, e[57] = K, e[58] = Q) : Q = e[58];
  let oe;
  return e[59] !== i || e[60] !== r || e[61] !== Q || e[62] !== s ? (oe = /* @__PURE__ */ l(Se, { open: s, anchorEl: i, onClose: r, anchorOrigin: Y, transformOrigin: W, children: Q }), e[59] = i, e[60] = r, e[61] = Q, e[62] = s, e[63] = oe) : oe = e[63], oe;
}, Re = (f) => {
  const e = ce(13), {
    columnId: t,
    anchorEl: i,
    onClose: r,
    options: x
  } = f, {
    getColumnById: h
  } = ae(), v = h(t)?.filterType || re.OPTIONS;
  if (v === re.TEXT) {
    let n;
    return e[0] !== i || e[1] !== t || e[2] !== r ? (n = /* @__PURE__ */ l(Ie, { columnId: t, anchorEl: i, onClose: r }), e[0] = i, e[1] = t, e[2] = r, e[3] = n) : n = e[3], n;
  }
  if (v === re.TIME_RANGE) {
    let n;
    return e[4] !== i || e[5] !== t || e[6] !== r ? (n = /* @__PURE__ */ l(Te, { columnId: t, anchorEl: i, onClose: r }), e[4] = i, e[5] = t, e[6] = r, e[7] = n) : n = e[7], n;
  }
  let S;
  return e[8] !== i || e[9] !== t || e[10] !== r || e[11] !== x ? (S = /* @__PURE__ */ l(Oe, { columnId: t, anchorEl: i, onClose: r, options: x }), e[8] = i, e[9] = t, e[10] = r, e[11] = x, e[12] = S) : S = e[12], S;
};
function ze(f, e) {
  return f[e.value.toString()] = e.label, f;
}
function Ne(f) {
  return f.value && typeof f.value == "object" && "value" in f.value ? f.value.value : f.value;
}
export {
  Re as default
};
